<div class="cr-week">
  <div class="cr-toolbar">
    <button type="button" (click)="gotoPrevWeek()">◀</button>
    <button type="button" (click)="gotoToday()">Today</button>
    <button type="button" (click)="gotoNextWeek()">▶</button>
    <div class="spacer"></div>
    <div class="range">
      {{ days()[0] | date:'EEE d MMM' }} — {{ days()[6] | date:'EEE d MMM' }}
    </div>
  </div>

  <div class="cr-header">
    <div class="gutter"></div>
    <div class="day" *ngFor="let d of days()">{{ d | date:'EEE d' }}</div>
  </div>

  <div class="cr-body" #grid>
    <!-- time gutter -->
    <div class="gutter">
      <div class="hour" *ngFor="let h of hours()">{{ (h < 10 ? '0'+h : h) + ':00' }}</div>
    </div>

    <!-- grid columns -->
    <div class="grid-columns">
      <div class="col" *ngFor="let d of days(); let dayIndex = index">
        <div class="slot"
             *ngFor="let s of [].constructor(totalSlots()); let i = index"
             [class.hour-border]="i % slotsPerHour() === 0"></div>
      </div>

      <!-- tasks layer -->
      <div class="tasks-layer" cdkDropListGroup>
        <div class="task-card"
             *ngFor="let t of tasks; trackBy: trackByTask"
             cdkDrag
             [cdkDragBoundary]="'.cr-body'"
             (cdkDragStarted)="onDragStart($event, t)"
             (cdkDragEnded)="onDragEnd($event, t)"
             [ngStyle]="taskStyle(t)">
          <div class="title">{{ t.title }}</div>
          <div class="time">{{ t.start | date:'HH:mm' }}–{{ t.end | date:'HH:mm' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
